import Backdraft from "backdraft-app/src/backdraft";

import React from 'react';
import createReactClass from 'create-react-class';
import BaseMixin from './BaseMixin';
import TerminalNameTerminal from './TerminalNameNode';

const Voice = createReactClass({
  displayName: 'Voice',
  mixins: [BaseMixin],

  render: function() {
    return (
      <form className="form-inline">
        <TerminalNameTerminal metaData={this.props.metaData} node={this.props.node} remove={this.props.remove} displayName="Spoken Phrases" editable={this.props.editable} />
        <span className="terminal-text-details" onClick={this._openEditor}>
          { this.props.node.get('phrase_array').length } { 'phrase' + (this.props.node.get('phrase_array').length === 1 ? '' : 's') }
          <span className="terminal-more-details">...</span>
        </span>
      </form>
    );
  },

  _openEditor: function() {
    // need to grab reference to the backdraft app - and the code actually uses the `app` reference internally (!)
    var app = Backdraft.app("Shared/SignalExpression");
    var modal = new app.Views.VoiceFormModal({
      model: this.props.node.get('voiceKeywords'),
      editable: this.props.editable
    });

    modal.render();
  }
});

export default Voice;
